import { render, staticRenderFns } from "./PersonalAddressBookView.vue?vue&type=template&id=152c6a98"
import script from "./PersonalAddressBookView.ts?vue&type=script&lang=ts&external"
export * from "./PersonalAddressBookView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports